var render, staticRenderFns
import script from "./ObjectUpdatesPromptableMixin.vue?vue&type=script&lang=ts&"
export * from "./ObjectUpdatesPromptableMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports